import { styled } from 'baseui'
import { FlexColumn, FlexCenter, FLOATING_GAP } from '@/shared/theme/styled-components'
import { RAIL_ICON_HOVER_SCALE } from '@/shared/theme/railSlot'

const floatingMenu = $expanded => ({
  position: 'sticky',
  top: FLOATING_GAP,
  height: `calc(100vh - 2 * ${FLOATING_GAP})`,
  overflowY: 'auto',
  width: $expanded ? 'max-content' : '3.5rem',
  minWidth: $expanded ? '12rem' : 0,
  padding: `${FLOATING_GAP} 0.5rem`,
  borderRadius: '0.5rem',
  alignItems: $expanded ? 'stretch' : 'center',
})

export const menuSlot = $fill => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  flex: '1 1 0',
  minHeight: '1.6875rem',
  maxHeight: $fill ? '3rem' : '2.25rem',
})

export const floatingButton = ($theme, $expanded) => ({
  width: $expanded ? '100%' : 'auto',
  height: '100%',
  aspectRatio: $expanded ? 'auto' : '1',
  padding: $expanded ? '0 0.75rem' : 0,
  justifyContent: $expanded ? 'flex-start' : 'center',
  gap: '0.75rem',
  borderTopLeftRadius: '0.5rem',
  borderTopRightRadius: '0.5rem',
  borderBottomRightRadius: '0.5rem',
  borderBottomLeftRadius: '0.5rem',
  backgroundColor: 'transparent',
  transition: 'background-color 0.12s',
  ':hover': { backgroundColor: $theme.colors.bg050 },
  ':hover svg': { transform: `scale(${RAIL_ICON_HOVER_SCALE})` },
})

export const StyledSidebarMenu = styled(FlexColumn, ({ $theme, $floating, $expanded }) => ({
  alignItems: 'center',
  padding: '1rem',
  height: '100%',
  width: '100%',
  backgroundColor: $theme.colors.white,
  ...($floating ? floatingMenu($expanded) : {}),
}))

export const StyledMenuToggleRow = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  flexShrink: 0,
  width: '100%',
  marginBottom: '0.25rem',
})

export const StyledSidebarLabel = styled('span', ({ $theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: '1.25rem',
  whiteSpace: 'nowrap',
  color: $theme.colors.contentPrimary,
}))

export const StyledSidebarButton = styled(FlexCenter, ({ $theme, $isSelected, $floating, $expanded }) => ({
  padding: '.25rem',
  backgroundColor: $isSelected ? $theme.colors.primary : $theme.colors.white,
  outlineOffset: '-.125rem',

  borderTopLeftRadius: $theme.borders.radius200,
  borderTopRightRadius: $theme.borders.radius200,
  borderBottomRightRadius: $theme.borders.radius200,
  borderBottomLeftRadius: $theme.borders.radius200,

  ':hover': {
    outline: `.125rem solid ${$theme.colors.primary}`,
  },

  ':not(:last-child)': {
    marginBottom: '1rem',
  },

  ...($floating ? { ...floatingButton($theme, $expanded), ':not(:last-child)': { marginBottom: 0 } } : {}),
}))

export const StyledSidebarDivButton = styled(FlexCenter, ({ $theme, $isSelected, $floating, $expanded }) => ({
  padding: '.25rem',
  backgroundColor: $isSelected ? $theme.colors.primary : $theme.colors.white,
  outlineOffset: '-.125rem',
  width: 'auto',

  borderTopLeftRadius: $theme.borders.radius200,
  borderTopRightRadius: $theme.borders.radius200,
  borderBottomRightRadius: $theme.borders.radius200,
  borderBottomLeftRadius: $theme.borders.radius200,

  ':hover': {
    outline: `.125rem solid ${$theme.colors.primary}`,
  },

  marginBottom: '1rem',

  ...($floating ? { ...floatingButton($theme, $expanded), marginBottom: 0 } : {}),
}))

export const logoOverrides = () => ({
  Svg: {
    style: () => ({
      height: 'auto',
      marginBottom: '0.5rem',
    }),
  },
})

export const tooltipOverrides = () => ({
  Body: {
    style: ({ $theme }) => ({
      margin: '.25rem',

      backgroundColor: 'none',

      boxShadow: $theme.lighting.shadow600,

      borderTopLeftRadius: $theme.borders.radius200,
      borderTopRightRadius: $theme.borders.radius200,
      borderBottomRightRadius: $theme.borders.radius200,
      borderBottomLeftRadius: $theme.borders.radius200,
    }),
  },
  Inner: {
    style: ({ $theme }) => ({
      backgroundColor: $theme.colors.white,

      color: $theme.colors.mono700,

      borderTopLeftRadius: $theme.borders.radius200,
      borderTopRightRadius: $theme.borders.radius200,
      borderBottomRightRadius: $theme.borders.radius200,
      borderBottomLeftRadius: $theme.borders.radius200,
      border: `2px solid ${$theme.colors.bg150}`,
    }),
  },
})
